/* global fetch */

const topNewsURL = 'https://s3.amazonaws.com/sos.texastribune.org/top-news/data.json';

export default function getTopNews () {
  return fetch(topNewsURL + '?__=' + +new Date()).then((res) => res.json());
}



// WEBPACK FOOTER //
// ./utils/get-top-news.js